// import { useNavigate } from "react-router-dom"
// import { useLogout } from "../hooks/useAuth"
// import WalletButton from "./WalletButton"
// import { useState } from "react"

// export default function Navbar() {
//   const navigate = useNavigate()
//   const logout = useLogout()
//   const user = JSON.parse(localStorage.getItem("user") || "{}")
//   const [menuOpen, setMenuOpen] = useState(false)

//   const handleLogout = () => {
//     logout()
//     navigate("/login")
//   }

//   return (
//     <nav className="bg-primary border-b border-secondary/30 text-white shadow-lg shadow-secondary/10">
//       <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
//         {/* Left section */}
//         <div className="flex items-center justify-between w-full md:w-auto">
//           <h1
//             className="text-2xl font-bold text-accent-cyan cursor-pointer"
//             onClick={() => navigate("/dashboard")}
//           >
//             NFT Marketplace
//           </h1>

//           {/* Mobile menu button */}
//           <button
//             className="md:hidden text-text-primary hover:text-secondary transition"
//             onClick={() => setMenuOpen(!menuOpen)}
//           >
//             {menuOpen ? (
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-6 w-6"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             ) : (
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-6 w-6"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
//               </svg>
//             )}
//           </button>
//         </div>

//         {/* Desktop Menu */}
//         <div className="hidden md:flex items-center gap-8">
//           <div className="flex gap-4">
//             <button
//               onClick={() => navigate("/dashboard")}
//               className="text-text-primary hover:text-secondary transition"
//             >
//               Dashboard
//             </button>
//             <button
//               onClick={() => navigate("/portfolio")}
//               className="text-text-primary hover:text-secondary transition"
//             >
//               Portfolio
//             </button>
//           </div>
//           <div className="flex items-center gap-4">
//             <WalletButton />
//             <span className="text-sm text-text-secondary">
//               {user.username || user.email}
//             </span>
//             <button
//               onClick={handleLogout}
//               className="bg-secondary/10 border border-secondary text-secondary px-4 py-2 rounded-lg hover:bg-secondary hover:text-primary transition"
//             >
//               Logout
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Dropdown */}
//       {menuOpen && (
//         <div className="md:hidden px-4 pb-4 space-y-3 border-t border-secondary/30">
//           <button
//             onClick={() => {
//               navigate("/dashboard")
//               setMenuOpen(false)
//             }}
//             className="block w-full text-left text-text-primary hover:text-secondary transition"
//           >
//             Dashboard
//           </button>
//           <button
//             onClick={() => {
//               navigate("/portfolio")
//               setMenuOpen(false)
//             }}
//             className="block w-full text-left text-text-primary hover:text-secondary transition"
//           >
//             Portfolio
//           </button>
//           <div className="flex flex-col gap-3 pt-3 border-t border-secondary/20">
//             <WalletButton />
//             <span className="text-sm text-text-secondary">
//               {user.username || user.email}
//             </span>
//             <button
//               onClick={() => {
//                 handleLogout()
//                 setMenuOpen(false)
//               }}
//               className="bg-secondary/10 border border-secondary text-secondary px-4 py-2 rounded-lg hover:bg-secondary hover:text-primary transition"
//             >
//               Logout
//             </button>
//           </div>
//         </div>
//       )}
//     </nav>
//   )
// }


import { useNavigate } from "react-router-dom"
import { useLogout } from "../hooks/useAuth"
import WalletButton from "./WalletButton"
import { useState, useEffect, useRef } from "react"

export default function Navbar() {
  const navigate = useNavigate()
  const logout = useLogout()
  const user = JSON.parse(localStorage.getItem("user") || "{}")
  const [menuOpen, setMenuOpen] = useState(false)

  // 🔹 Random NFT purchase message logic
  const MESSAGE = "Someone just purchased an NFT!"
  const messageIntervals = [
    10 * 60 * 1000,
    6 * 60 * 1000,
    1 * 60 * 1000,
    3 * 60 * 1000,
    4 * 60 * 1000,
  ]
  const [showMessage, setShowMessage] = useState(false)
  const timers = useRef([])

  useEffect(() => {
    const triggerMessage = () => {
      setShowMessage(true)

      const hideTimer = setTimeout(() => setShowMessage(false), 5000)
      timers.current.push(hideTimer)

      const nextDelay =
        messageIntervals[Math.floor(Math.random() * messageIntervals.length)]

      const nextTimer = setTimeout(triggerMessage, nextDelay)
      timers.current.push(nextTimer)
    }

    // Start first message after 60 seconds
    const firstTimer = setTimeout(triggerMessage, 60000)
    timers.current.push(firstTimer)

    return () => {
      timers.current.forEach(clearTimeout)
      timers.current = []
    }
  }, [])

  const handleLogout = () => {
    logout()
    navigate("/login")
  }

  return (
    <div>
      {/* Navbar */}
      <nav className="bg-primary border-b border-secondary/30 text-white shadow-lg shadow-secondary/10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          {/* Left section */}
          <div className="flex items-center justify-between w-full md:w-auto">
            <h1
              className="text-2xl font-bold text-accent-cyan cursor-pointer"
              onClick={() => navigate("/dashboard")}
            >
              NFT Marketplace
            </h1>

            {/* Mobile menu button */}
            <button
              className="md:hidden text-text-primary hover:text-secondary transition"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {menuOpen ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <div className="flex gap-4">
              <button
                onClick={() => navigate("/dashboard")}
                className="text-text-primary hover:text-secondary transition"
              >
                Dashboard
              </button>
              <button
                onClick={() => navigate("/portfolio")}
                className="text-text-primary hover:text-secondary transition"
              >
                Portfolio
              </button>
            </div>
            <div className="flex items-center gap-4">
              <WalletButton />
              <span className="text-sm text-text-secondary">
                {user.username || user.email}
              </span>
              <button
                onClick={handleLogout}
                className="bg-secondary/10 border border-secondary text-secondary px-4 py-2 rounded-lg hover:bg-secondary hover:text-primary transition"
              >
                Logout
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Dropdown */}
        {menuOpen && (
          <div className="md:hidden px-4 pb-4 space-y-3 border-t border-secondary/30">
            <button
              onClick={() => {
                navigate("/dashboard")
                setMenuOpen(false)
              }}
              className="block w-full text-left text-text-primary hover:text-secondary transition"
            >
              Dashboard
            </button>
            <button
              onClick={() => {
                navigate("/portfolio")
                setMenuOpen(false)
              }}
              className="block w-full text-left text-text-primary hover:text-secondary transition"
            >
              Portfolio
            </button>
            <div className="flex flex-col gap-3 pt-3 border-t border-secondary/20">
              <WalletButton />
              <span className="text-sm text-text-secondary">
                {user.username || user.email}
              </span>
              <button
                onClick={() => {
                  handleLogout()
                  setMenuOpen(false)
                }}
                className="bg-secondary/10 border border-secondary text-secondary px-4 py-2 rounded-lg hover:bg-secondary hover:text-primary transition"
              >
                Logout
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* 🔹 Random NFT Purchase Message */}
      {showMessage && (
        <div className="bg-gradient-to-r from-accent-cyan/20 to-secondary/20 text-accent-cyan text-center py-2 text-sm font-medium transition-opacity duration-700 ease-in-out animate-pulse">
          {MESSAGE}
        </div>
      )}
    </div>
  )
}
